import { Layout } from '../components/layout'
import { useNavigate } from 'react-router-dom'
import { Button } from '../components/button'

export default function CheckoutSuccess() {
  const navigate = useNavigate()

  return (
    <Layout title="Success 🎉">
      <p>You&apos;re all set and we&apos;ve just emailed you your receipt. </p>
      <p>
        <b>Note: </b>
        It may take a few minutes before the updated plan appears in your
        account.
      </p>
      <Button
        text="To the dashboard"
        onClick={() => navigate('/dashboard')}
      />
    </Layout>
  )
}
